import { useState } from 'react'
import BrandCategoryLogo from './BrandCategoryLogo'
import { manufacturerLogoSrc } from '@redevicer/shared'
import { brandLogoKeyForManufacturer } from '../utils/brandManufacturerMap'

type Props = {
  manufacturer: string
  size?: number
  className?: string
}

/** Curated smartphone logo or `/brands/manufacturers/{slug}.png`, then letter fallback. */
export default function ManufacturerLogo({ manufacturer, size = 40, className = '' }: Props) {
  const curated = brandLogoKeyForManufacturer(manufacturer)
  const [failed, setFailed] = useState(false)

  if (curated) {
    return <BrandCategoryLogo brand={curated} size={size} className={className} />
  }

  if (!failed) {
    return (
      <img
        src={manufacturerLogoSrc(manufacturer)}
        alt=""
        width={size}
        height={size}
        className={`vc-brand-logo-img vc-brand-logo-img--mfg ${className}`.trim()}
        style={{ objectFit: 'contain', display: 'block' }}
        onError={() => setFailed(true)}
        draggable={false}
      />
    )
  }

  return (
    <span className="model-picker__brand-fallback" aria-hidden="true">
      {manufacturer.charAt(0)}
    </span>
  )
}
